import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.018 12.042v-2.04c0-4.417 3.587-8.002 8-8.002 4.418 0 8 3.584 8 8.002v11.996c0 1.203-.267 2.37-.774 3.435a1 1 0 0 1-1.333.473L16.018 12.042ZM30.624 32.02l-2.92-2.92a8.002 8.002 0 0 1-11.686-7.102v-4.584L6.311 7.707c-.943-.943.471-2.357 1.414-1.414l34 34c.943.943-.471 2.357-1.414 1.414l-8.248-8.248a13.925 13.925 0 0 1-7.046 2.506l.001.035v8h4c1.333 0 1.333 2 0 2h-10c-1.333 0-1.333-2 0-2h4v-8.035c-7.265-.513-13-6.568-13-13.965a1 1 0 1 1 2 0c0 6.628 5.372 12 12 12 2.388 0 4.667-.698 6.606-1.98ZM37.018 21a1 1 0 0 0-1 1 11.94 11.94 0 0 1-2.146 6.85 1 1 0 1 0 1.641 1.144A13.94 13.94 0 0 0 38.018 22a1 1 0 0 0-1-1Z",
    fill: "currentColor"
  }));
};

var SvgMicOff = styled(SvgComponent).withConfig({
  displayName: "MicOff__SvgMicOff",
  componentId: "sc-1gomc9r-0"
})(["", " ", ""], size, color);
export default SvgMicOff;